import { render } from "./StoreGiftRecordList.vue?vue&type=template&id=d620389e&scoped=true"
import script from "./StoreGiftRecordList.vue?vue&type=script&lang=js"
export * from "./StoreGiftRecordList.vue?vue&type=script&lang=js"

import "./StoreGiftRecordList.vue?vue&type=style&index=0&id=d620389e&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d620389e"]])

export default __exports__